import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class YesNoGroupButtonService {

public getNextId(): string {
  this.iterationNumber++;
  return `id-${this.iterationNumber}`;
}

private iterationNumber = 0;

constructor() { }

}
